"use client";

import { InvestorDeckForm } from "@/components/forms/InvestorDeckForm";
import { Container } from "@/components/primitives/Container";
import { Eyebrow } from "@/components/primitives/Eyebrow";
import { getAudiences } from "@/content/audiences";
import { getFormsCopy } from "@/content/forms";
import { useLocale } from "@/lib/i18n/provider";

export function InvestorsDeckSection() {
  const { locale } = useLocale();
  const investors = getAudiences(locale).investors;
  const forms = getFormsCopy(locale);

  return (
    <section id="deck" className="relative pb-24 md:pb-32">
      <Container>
        <div className="mx-auto max-w-2xl rounded-3xl border border-[var(--color-surface-border)] bg-[var(--color-surface-glass)] p-8 md:p-10">
          <Eyebrow>{investors.eyebrow}</Eyebrow>
          <h2 className="mt-4 text-[clamp(1.5rem,3vw,2rem)] font-bold tracking-tight text-[var(--color-text-primary)]">
            {investors.cta.label}
          </h2>
          <p className="mt-3 text-[15px] leading-relaxed text-[var(--color-text-secondary)]">
            {forms.modals.investorDeck.description}
          </p>
          <div className="mt-8">
            <InvestorDeckForm />
          </div>
        </div>
      </Container>
    </section>
  );
}

export default InvestorsDeckSection;
